var React = require('react');

function Loader3 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1_333)","key":0},[React.createElement("rect",{"width":"90","height":"22","fill":"white","key":0}),React.createElement("rect",{"y":"44","width":"90","height":"22","fill":"white","key":1}),React.createElement("rect",{"y":"88","width":"90","height":"22","fill":"white","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1_333"},React.createElement("rect",{"width":"90","height":"110","fill":"white"})))]);
}

Loader3.defaultProps = {"width":"90","height":"110","viewBox":"0 0 90 110","fill":"none"};

module.exports = Loader3;

Loader3.default = Loader3;
